<template>
  <div id="app" class="app" :class="{blue:theme==='blue' }" >
    <router-view />

  </div>
</template>
<script >
function getQueryVariable(variable) {
  var query = window.location.search.substring(1)
  var vars = query.split("&")
  console.log(query)
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=")
    if (pair[0] == variable) {
      return pair[1]
    }
  }
  return false
}
let user = getQueryVariable("tk")
console.log(user)
if (user) {
  localStorage.setItem("token", user)
} else {
  // if(window.location.href.indexOf('dig.gclingyu.com')!==-1){
  //   window.location.href ='https://bzf.gclingyu.com'
  // }
}
/* eslint-disable */
const changeTheme = () => {
  const body = document.querySelector("body")
  if (body.classList.contains("red")) {
    body.classList.remove("red")
    body.classList.add("blue")
  } else {
    body.classList.remove("blue")
    body.classList.add("red")
  }
}
export default {
  data() {
    return {
      isBlue:false
    }
  },
  methods: {
    changeTheme,
  },
  computed: {
    theme() {
      return this.$store.state.theme
    }
  },
  created() {
    const theme = localStorage.getItem("theme")
    this.$store.commit('setTheme', theme)
  },
}
</script>
<style lang="scss" scoped>
.app {
  width: 100vw;
  height: 100vh;
  background-color: rgba(117, 40, 34, 1);
  overflow: hidden;
}
.blue{
  background-color: #16337F;
}
</style>
